/** Labels y helpers para reglas efímeras de sesión del agente de abastecimiento. */

import {
  formatSupplyAgentRuleLabel,
  type SupplyAgentRuleRecord,
} from '@/modules/supply/components/supplyAgentRuleUtils';

/** Flag solo FE: no se envía al engine (se limpia en `activeSessionEphemeralRules`). */
export const SESSION_EPHEMERAL_ENABLED_KEY = '__session_enabled';

export function labelSessionEphemeralRule(rule: Record<string, unknown>): string {
  return formatSupplyAgentRuleLabel(rule as SupplyAgentRuleRecord);
}

export function isSessionEphemeralRuleEnabled(rule: Record<string, unknown>): boolean {
  return rule[SESSION_EPHEMERAL_ENABLED_KEY] !== false;
}

export function withSessionEphemeralEnabled(
  rule: Record<string, unknown>,
  enabled = true,
): Record<string, unknown> {
  return { ...rule, [SESSION_EPHEMERAL_ENABLED_KEY]: enabled };
}

export function stripSessionEphemeralMeta(
  rule: Record<string, unknown>,
): Record<string, unknown> {
  const { [SESSION_EPHEMERAL_ENABLED_KEY]: _ignored, ...rest } = rule;
  return rest;
}

/** Reglas de sesión activas, listas para `ephemeral_rules` del API. */
export function activeSessionEphemeralRules(
  rules: Record<string, unknown>[],
): Record<string, unknown>[] {
  return rules.filter(isSessionEphemeralRuleEnabled).map(stripSessionEphemeralMeta);
}
